import {StyleSheet} from 'react-native';

export default StyleSheet.create({
  itemInputStyle: {
    borderWidth: 1,
    borderColor: 'rgba(224, 224, 224, 1)',
    borderRadius: 30,
    backgroundColor: '#fff',
    color: '#000',
    fontSize: 14,
    flexDirection: 'row',
    marginTop: 5,
    paddingLeft: 10,
    height: 50,
  },
  chip: {
    flexDirection: 'row',
    backgroundColor: 'rgba(240, 244, 248, 0.87)',
    padding: 2,
    paddingStart: 10,
    marginVertical: 5,
    borderRadius: 30,
    marginRight: 15,
    alignItems: 'center',
  },
  removeBtn: {
    borderWidth: 1,
    borderColor: 'rgba(240, 244, 248, 0.87)',
    backgroundColor: 'rgba(240, 244, 248, 0.87)',
    height: 20,
    width: 20,
    borderRadius: 15,
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
    top: -17,
    right: -17,
  },
  uploadBtnWrapper: {
    right: 10,
    top: 17,
    position: 'absolute',
  },
  uploadBtn: {
    width: 70,
    height: 40,
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    paddingVertical: 3,
  },
});
